import { convertFromRaw, RawDraftContentState } from "draft-js";

const ESCAPE_MAP: Record<string, string> = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
};

function escapeHtml(text: string): string {
  return text.replace(/[&<>"']/g, (ch) => ESCAPE_MAP[ch]);
}

export function simpleFormat(text: string | null | undefined): string {
  if (!text) return "";

  const escaped = escapeHtml(text);
  return escaped
    .split(/\n\n+/)
    .map((block) => `<p>${block.replace(/\n/g, "<br />")}</p>`)
    .join("\n\n");
}

export function contentStateToHtml(
  raw: RawDraftContentState | null | undefined
): string {
  if (!raw) return "";

  const content = convertFromRaw(raw);
  const plainText = content.getPlainText("\n\n");
  return simpleFormat(plainText);
}
